module.exports = __webpack_public_path__ + "img/google_play_badge.65cc4515.jpg";